import {connect} from 'react-redux'

import type {State} from '../../../reducers/types'
import {getIsSakuraUI} from '../../../selectors'

import BuildStatus from './BuildStatus'
import type {StateProps} from './BuildStatus.types'

const mapStateToProps = (state: State): StateProps => ({
  showDropdown: !getIsSakuraUI(state),
})

export default connect(mapStateToProps)(BuildStatus)
